import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';
import FromAccountDetails
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/FromAccountDetails/FromAccountDetails';
import ToAccountDetails
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/ToAccountDetails/ToAccountDetails';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';

const AccountDetailsSection = () => {
  const { resource } = useMetaLayoutContext();
  const { setIsContentShowing } = useLottieLoadingContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);
  return (

    <FDStack direction={'column'} spacing={2}>
      {resource.withRelationship(
        fr.relationships.transferLottieHorizontal.name,
        (rel) => (<LottieRel relationship={rel} width={'100%'} />),
        () => null,
      )}
      <FDStack direction={'row'} justifyContent={'space-between'} spacing={0} alignItems={'flex-start'}>
        <FromAccountDetails />
        <ToAccountDetails />
      </FDStack>
    </FDStack>
  );
};

AccountDetailsSection.defaultProps = {
};

AccountDetailsSection.propTypes = {
};

export default AccountDetailsSection;
